import { takeEvery, call, fork, put } from 'redux-saga/effects';
import { MergeFieldsLoadError, MergeFieldsLoadSuccess } from '@/store/mergeFields/actions';
import { MergeFieldsActionTypes } from '@/store/mergeFields/types';
import { getMergeField } from '@/services/ApiCategories/mergeField';
import { errorToast } from './commonGenerators/errorToast';

function* loadMergeFields(): any {
    try {
        const response = yield call(getMergeField);
        yield put(MergeFieldsLoadSuccess(response.data));
    } catch (e) {
        yield put(MergeFieldsLoadError());
        yield call(errorToast, e);
    }
}

function* watchLoadStart(): any {
    yield takeEvery(MergeFieldsActionTypes.LOAD_START, loadMergeFields);
}

const mergeFieldsSagas = [fork(watchLoadStart)];

export default mergeFieldsSagas;
